import InstitutionAccountState from "@/models/Accounts/InstitutionAccounts/InstitutionAccountState";

export default (val: InstitutionAccountState) => {
    let returnVal = "Undefined";
    switch (val) {
        case InstitutionAccountState.Enabled:
            returnVal = "Enabled"
            break;
    }
    return returnVal;
}